export default __webpack_public_path__ + "static/media/photo22.c04a5c77.jpg";